// extracted by mini-css-extract-plugin
export var cardLayout = "_6r-1";
export var paginationContainer = "_6r-0";